import axios from '@/axios'

export default {
  fetchAll(params, id){
    return axios.get(`/order-details/all/${id}`, {params})
  },
  fetchLimit(params, id){
    return axios.get(`/order-details/limit/${id}`, {params})
  },  
  fetchById(id){
    return axios.get(`/order-details/${id}`)
  },    
  create(payload){
    return axios.post(`/order-details`, payload)
  },
  update(id, payload){
    return axios.put(`/order-details/${id}`, payload)
  },
  delete(id){
    return axios.delete(`/order-details/${id}`)
  }, 
  deleteMultiple(payload){
    return axios.delete(`/order-details`, payload)
  }
}